import {
    getReconciliationMonthlyStatusService,
    getReconciliationReportService,
    getReconciliationTransactionDetailsService
} from "../../services/carrierReconciliationReport.service";
import { formatNumberWithCommas, formatStaticNumberWithCommas } from "../../config/utils";

export const GET_RECONCILIATION_REPORT_PENDING = 'GET_RECONCILIATION_REPORT_PENDING';
export const GET_RECONCILIATION_REPORT_SUCCESS = 'GET_RECONCILIATION_REPORT_SUCCESS';
export const GET_RECONCILIATION_REPORT_FAILURE = 'GET_RECONCILIATION_REPORT_FAILURE';

export const GET_RECONCILIATION_TRANSACTION_DETAILS_PENDING = 'GET_RECONCILIATION_TRANSACTION_DETAILS_PENDING';
export const GET_RECONCILIATION_TRANSACTION_DETAILS_SUCCESS = 'GET_RECONCILIATION_TRANSACTION_DETAILS_SUCCESS';
export const GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE = 'GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE';

export const GET_CARRIER_PROFIT_SUCCESS = 'GET_CARRIER_PROFIT_SUCCESS';
export const GET_CARRIER_PROFIT_PENDING = 'GET_CARRIER_PROFIT_PENDING';
export const GET_CARRIER_PROFIT_FAILURE = 'GET_CARRIER_PROFIT_FAILURE';

/* istanbul ignore next */
export const getReconciliationReport = (data) => {
    return (dispatch) => {
        dispatch({ type: GET_RECONCILIATION_REPORT_PENDING });
        getReconciliationReportService(data).then((result) => {
            let dataList = result.data.Entity || {};
            let listUpdate = dataList.monthlyReports.map((item, index) => {
                const creditClass = item.profit > 0 ? "credit" : "pending";
                return {
                    ...item,
                    profit: item.profit ? `<span class='${creditClass}'>
                         $ ${formatNumberWithCommas(item.profit)}</span>` : null,
                    id: index + 1,
                    matchedTrackingNumberCount: formatStaticNumberWithCommas(item.matchedTrackingNumberCount) || 0,
                    unMatchedTrackingNumberCount: formatStaticNumberWithCommas(item.unMatchedTrackingNumberCount) || 0,
                    month: `${item.monthName.slice(0, 3)} ${item.year}`,
                    disputedTrackingNumberCount: formatStaticNumberWithCommas(item.disputedTrackingNumberCount) || 0
                };
            });
            dataList.monthlyReports = listUpdate;
            dispatch({
                type: GET_RECONCILIATION_REPORT_SUCCESS,
                payload: {
                    data: dataList || {},
                    totalRecords: result.data.TotalRecords || 0
                }
            });
        }).catch((error) => {
            console.error("Error fetching data", error);
        });
    }
};
/* istanbul ignore next */
export const getReconciliationTransactionDetails = (data) => {
    return (dispatch) => {
        dispatch({ type: GET_RECONCILIATION_TRANSACTION_DETAILS_PENDING });
        return getReconciliationTransactionDetailsService(data)
            .then((result) => {
                // Check both uppercase and lowercase status for compatibility
                const status = result?.data?.Status || result?.data?.status;
                const entityList = result?.data?.EntityList || result?.data?.entityList || [];
                const totalRecords = result?.data?.TotalRecords || result?.data?.totalRecords || 0;
                
                if (status === 200) {
                    dispatch({
                        type: GET_RECONCILIATION_TRANSACTION_DETAILS_SUCCESS,
                        payload: {
                            data: entityList,
                            totalRecords: totalRecords
                        }
                    });
                    return { success: true, data: { entityList, totalRecords } };
                } else {
                    const errorMessage = result?.data?.Message?.AppStatusDescription || 
                                       result?.data?.message?.description || 
                                       'Failed to fetch transaction details';
                    dispatch({
                        type: GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE,
                        payload: errorMessage
                    });
                    return { success: false, message: errorMessage };
                }
            })
            .catch((error) => {
                const errorMessage = error?.response?.data?.Message?.AppStatusDescription || 
                                   error?.response?.data?.message?.description || 
                                   error?.response?.data?.message ||
                                   error?.message || 
                                   'Something went wrong while fetching transaction details';
                dispatch({
                    type: GET_RECONCILIATION_TRANSACTION_DETAILS_FAILURE,
                    payload: errorMessage
                });
                return { success: false, message: errorMessage };
            });
    };
};

/* istanbul ignore next */
export const getCarrierProfitReports = (data) => {
    return (dispatch) => {
        dispatch({ type: GET_CARRIER_PROFIT_PENDING });
        getReconciliationMonthlyStatusService(data).then((result) => {
            let dataList = result.data.Entity || {};
            let listUpdate = dataList.monthlyStatements.map((item, index) => {
                const creditClass = item.profit > 0 ? "credit" : "pending";
                return {
                    ...item,
                    
                    profit: item.profit ? `<span class='${creditClass}'>
                         $ ${formatNumberWithCommas(item.profit)}</span>` : null,
                    walletBalance: `$ ${formatNumberWithCommas(item.walletBalance || 0)}`,
                    labelCreationCount: formatStaticNumberWithCommas(item.labelCreationCount) || 0,
                    labelRefundCount: formatStaticNumberWithCommas(item.labelRefundCount) || 0,
                    labelAdjustmentCount: formatStaticNumberWithCommas(item.labelAdjustmentCount) || 0,
                    id: index + 1,
                    labelAdjustment: `$ ${formatNumberWithCommas(item.labelAdjustment ?? 0)}`,
                    month: `${item.monthName.slice(0, 3)} ${item.year}`,
                    labelPurchased: formatNumberWithCommas(item.labelPurchased) || 0,
                    totalCollection: formatNumberWithCommas(item.totalCollection) || 0,
                    labelRefund: formatNumberWithCommas(item.labelRefund) || 0,
                    carrierClosingBalance: `$ ${formatNumberWithCommas(item.carrierClosingBalance ?? 0)}`,
                    carrierRevenue: `$ ${formatNumberWithCommas(item.carrierRevenue ?? 0)}`,
                };
            });
            dispatch({
                type: GET_CARRIER_PROFIT_SUCCESS,
                payload: {
                    monthlyStatements: listUpdate || [],
                    totalRecords: result.data.TotalRecords,
                    carrierTotals: result.data.Entity.totals || {}
                }
            });
        }).catch((error) => {
            console.error("Error fetching data", error);
        });
    }
};